/* Bundle upsell (MK) — product page.

   Row 0 is the product being viewed and is always in the bundle; it mirrors the PDP
   variant picker one way (PDP → bundle), never the other way round. The remaining rows
   carry a checkbox and are filled from the metafield server-side, or fetched from Shopify
   recommendations when the metafield is empty.

   Everything is bound by DELEGATION on the container, so rows that arrive by AJAX need no
   re-init. */
(function () {
  if (window.__mkUpsBundle) return;
  window.__mkUpsBundle = true;

  var CART_ADD = (window.T4Sroutes && T4Sroutes.cart_add_url ? T4Sroutes.cart_add_url : '/cart/add') + '.js';

  /* ---------- money ---------- */
  function money(cents, format) {
    var noDec = /no_decimals/.test(format || '');
    var v = (cents / 100);
    v = noDec ? String(Math.round(v)) : v.toFixed(2);
    v = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (!format) return v;
    return format.replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  /* ---------- rows ---------- */
  function rows(box) { return Array.prototype.slice.call(box.querySelectorAll('[data-mk-ups-row]')); }

  function picked(row) {
    if (row.dataset.self === '1') return true;
    var cb = row.querySelector('[data-mk-ups-check]');
    return !!(cb && cb.checked);
  }

  function chosen(row) {
    var sel = row.querySelector('[data-mk-ups-size]');
    if (!sel) return null;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return null;
    return { id: opt.value, price: parseInt(opt.dataset.price, 10) || 0, ok: !opt.disabled };
  }

  /* ---------- paint ---------- */
  function paint(box) {
    var fmt = box.dataset.moneyFormat || '';
    var total = 0, count = 0, blocked = false;

    rows(box).forEach(function (row) {
      var on = picked(row);
      row.classList.toggle('is--off', !on);
      var c = chosen(row);
      var price = row.querySelector('[data-mk-ups-price]');
      if (c && price) price.textContent = money(c.price, fmt);
      if (!on) return;
      count++;
      if (!c || !c.ok) { blocked = true; return; }
      total += c.price * qtyOf(row);
    });

    var out = box.querySelector('[data-mk-ups-total]');
    if (out) out.textContent = money(total, fmt);

    var btn = box.querySelector('[data-mk-ups-add]');
    if (btn) btn.disabled = blocked || count < 1;

    var self = box.querySelector('[data-mk-ups-self-label]');
    if (self && !self.textContent) self.textContent = box.dataset.selfLabel || '';

    if (window.jQuery) { try { jQuery(document).trigger('currency:update'); } catch (e) {} }
  }

  /* row 0 follows the PDP quantity stepper; every other row is a single unit */
  function qtyOf(row) {
    if (row.dataset.self !== '1') return 1;
    var q = document.querySelector('form[id^="product-form-"] [name="quantity"], .t4s-product__info-wrapper [name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  /* ---------- PDP → row 0 ---------- */
  function mainVariantEl() {
    return document.querySelector('form[id^="product-form-"] [name="id"]');
  }

  function syncSelf(box) {
    var el = mainVariantEl();
    if (!el || !el.value) return;
    var row = box.querySelector('[data-mk-ups-row][data-self="1"]');
    if (!row) return;
    var sel = row.querySelector('[data-mk-ups-size]');
    if (!sel || sel.value === el.value) return;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === String(el.value)) { sel.selectedIndex = i; paint(box); return; }
    }
    /* the PDP moved to a variant this row cannot show (a different colour) — the bundle
       is about THIS colour, so leave the row alone rather than lying about it. */
  }

  /* The theme sets [name="id"] with .value, which fires no event and mutates no attribute,
     so neither a listener nor a MutationObserver can see it. A cheap string compare is the
     only honest way to follow it. */
  function watchSelf(box) {
    var last = '';
    setInterval(function () {
      var el = mainVariantEl();
      var v = el ? String(el.value || '') : '';
      if (v && v !== last) { last = v; syncSelf(box); }
    }, 300);
  }

  /* ---------- add ---------- */
  function openDrawer() {
    var t = document.querySelector('[data-drawer-options*="t4s-mini_cart"]');
    if (t) t.click();
  }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.classList.remove('t4s-op-0');
    });
  }

  function showErr(box, msg) {
    var el = box.querySelector('[data-mk-ups-err]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    setTimeout(function () { el.hidden = true; }, 5000);
  }

  function flashOK(box) {
    var t = box.querySelector('[data-mk-ups-btn-text]');
    if (!t) return;
    t.textContent = box.dataset.addedLabel || 'Added';
    setTimeout(function () { t.textContent = box.dataset.btnLabel || 'Add bundle to cart'; }, 2200);
  }

  function add(box) {
    var btn = box.querySelector('[data-mk-ups-add]');
    if (!btn || btn.disabled || btn.classList.contains('is--loading')) return;

    /* one entry per variant — the same variant twice would be two lines Shopify merges
       anyway, and an items[] POST is atomic, so it is cleaner to merge here */
    var order = [], seen = {};
    rows(box).forEach(function (row) {
      if (!picked(row)) return;
      var c = chosen(row);
      if (!c || !c.ok) return;
      if (seen[c.id]) { seen[c.id].quantity += qtyOf(row); return; }
      seen[c.id] = { id: c.id, quantity: qtyOf(row) };
      order.push(seen[c.id]);
    });
    if (!order.length) return;

    btn.classList.add('is--loading');
    fetch(CART_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: order })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        btn.classList.remove('is--loading');
        if (!res.ok) {
          showErr(box, res.body.description || res.body.message || 'Sorry, that could not be added.');
          return;
        }
        flashOK(box);
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          setCount(c.item_count);
          /* Kalles only re-renders the drawer on its own 'cart:refresh' event; without it
             the drawer keeps the HTML from page load and shows "Your cart is empty". */
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          openDrawer();
        });
      })
      .catch(function () {
        btn.classList.remove('is--loading');
        showErr(box, 'Sorry, that could not be added.');
      });
  }

  /* ---------- recommendations fallback ---------- */
  function fill(box) {
    if (box.dataset.needsRecs !== '1' || box.dataset.mkUpsDone === '1') return;
    box.dataset.mkUpsDone = '1';
    var id = box.dataset.productId, limit = box.dataset.limit || 3;
    if (!id) return;
    var url = (window.T4Sroutes && T4Sroutes.product_recommendations_url ? T4Sroutes.product_recommendations_url : '/recommendations/products')
      + '?section_id=mk-upsell-recs&product_id=' + encodeURIComponent(id)
      + '&limit=' + encodeURIComponent(limit)
      + '&intent=' + encodeURIComponent(box.dataset.intent || 'related');
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var cards = tmp.querySelectorAll('[data-mk-ups-row]');
        if (!cards.length) return;                 /* nothing to bundle with — stay hidden */
        var list = box.querySelector('[data-mk-ups-list]');
        var n = 0, max = parseInt(limit, 10) || 3;
        Array.prototype.forEach.call(cards, function (c) {
          if (n >= max) return;
          if (c.dataset.pid && c.dataset.pid === box.dataset.productId) return;
          list.appendChild(c); n++;
        });
        if (!n) return;
        box.hidden = false;
        paint(box);
      })
      .catch(function () {});
  }

  /* ---------- init ---------- */
  function init(box) {
    if (box.dataset.mkUpsInit === '1') return;
    box.dataset.mkUpsInit = '1';

    box.addEventListener('change', function (e) {
      if (e.target.matches('[data-mk-ups-check], [data-mk-ups-size]')) paint(box);
    });
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-mk-ups-add]')) add(box);
    });

    fill(box);
    syncSelf(box);
    paint(box);
    watchSelf(box);
  }

  function run() { document.querySelectorAll('[data-mk-ups]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
